import * as React from 'react';

import type { HiveWorkingBranch, HiveWorkingDocument } from '@gitbook/hive-client';

/**
 * Hook to subscribe to the read-only property of a Hive document or revision.
 */
export function useHiveReadOnly(model: HiveWorkingDocument | HiveWorkingBranch): boolean {
    const readOnlySubscription = React.useMemo(() => {
        return {
            getCurrentValue: () => model.dataSync.readOnly,
            subscribe: (callback) => {
                return model.dataSync.listen('readOnly', (readOnly) => callback(readOnly));
            },
        };
    }, [model]);

    const value = React.useSyncExternalStore(
        readOnlySubscription.subscribe,
        readOnlySubscription.getCurrentValue
    );

    return value;
}
